
/* eslint-disable @typescript-eslint/restrict-plus-operands */
import React, { Dispatch, SetStateAction, memo, useCallback, useContext, useEffect, useRef, useState } from "react";
import { MediaSettingsContext, SettingsContext } from "../../DMSMedia";
import DummyCard from "./DummyCard";
import { AntmediaContext } from "../../../../App";
import clsx from "clsx";
import './style.css';
import MicMute from "@ht/shared/fonts/deos-pis/mic-mute";
import AudioAnalyser from "../visualizer/AudioAnalyzer";
interface IProps {
  srcObject?: any;
  hidePin?: boolean;
  onHandlePin(): void;
  id: string;
  track?: any;
  autoPlay: boolean;
  pinned?: boolean;
  name?: string;
  muted?: boolean;
  style?: any;
  hideTalkingIndicator?: boolean;
}
const onTrackEnded = (
  participants: any[],
  settings: any,
  callBack: (oldParts: any) => any[],
  props: any
) => {
  if (participants.length > settings?.globals?.maxVideoTrackCount) {
    callBack((oldParts: any) => {
      return oldParts.filter(
        (p: any) => !(p.id === props.id || p.videoLabel === props.id)
      );
    });
  }
};
const enableAudioLevelLocalStream = (
  value: number,
  isTalking: any,
  setIsTalking: Dispatch<SetStateAction<boolean>>,
  timeoutRef: any,
  antmedia: any,
  mediaSettings: any
) => {

  // sounds under 0.01 are probably background noise
  if (value >= 0.01) {
    if (isTalking === false) setIsTalking(true);
    clearInterval(timeoutRef.current as NodeJS.Timeout);
    timeoutRef.current = setTimeout(() => {
      setIsTalking(false);
    }, 800);
    antmedia.updateAudioLevel(
      mediaSettings?.myLocalData?.streamId,
      Math.floor(value * 100)
    );
  }

}
const audioView = (mic: any, props: any, srcobj: any) => mic?.isMicMuted ?
  props.id !== "localVideo" &&
  <div className="flex flex-row h-[20px] items-center gap-[2px] bg-primary-200 p-[4px] rounded-lg ">
    <MicMute className={clsx("text-white w-[14px] h-[14px]")} /> <span className="text-sm font-semibold text-white">muted</span>
  </div>
  :
  srcobj && <><AudioAnalyser audio={srcobj}></AudioAnalyser></>


const checkIsOff = (mediaSettings: any, props: any) => {
  let isOff = mediaSettings?.cam?.find(
    (c: any) => c.eventStreamId === props?.id && !c?.isCameraOn
  );
  isOff = isOff ?? true;

  // if i sharing my screen.
  if (
    mediaSettings.isScreenShared === true &&
    props?.id === "localVideo" &&
    mediaSettings?.cam.find(
      (c: any) => c.eventStreamId === "localVideo" && c.isCameraOn === false
    )
  ) {
    isOff = false;
  }
  // screenSharedVideoId is the id of the screen share video.
  if (
    mediaSettings.screenSharedVideoId === props?.id &&
    mediaSettings?.cam.find(
      (c: any) => c.eventStreamId === props?.id && c.isCameraOn === false
    )
  ) {
    isOff = false;
  }
  return isOff;
}
const AudioCard = memo(({ srcObject, hidePin, onHandlePin, hideTalkingIndicator, pinned, name, ...props }: IProps) => {
  const timeoutRef: { current: NodeJS.Timeout | null } = useRef(null);
  const mediaSettings = useContext(MediaSettingsContext);
  const settings = useContext(SettingsContext);
  const antmedia = useContext(AntmediaContext);
  const { setParticipants, participants } = mediaSettings;
  const [srcobj, setSrcobj] = useState<MediaStream>();


  const refVideo = useCallback(
    (node) => {
      if (node && props.track) {
        node.srcObject = new MediaStream([props.track]);
        console.log("src obj", node.srcObject)
        setSrcobj(node.srcObject);
      }
    },
    [props.track]
  );
  const isOff = checkIsOff(mediaSettings, props)

  React.useEffect(() => {
    if (props.track?.kind === "video" && !props.track.onended) {
      props.track.onended = (event: any) => {
        onTrackEnded(
          participants,
          settings,
          setParticipants,
          props
        );
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.track]);

  const mic = mediaSettings?.mic?.find((m: any) => m.eventStreamId === props?.id);

  const [isTalking, setIsTalking] = React.useState(false);

  const isLocal = props?.id === "localVideo";
  const mirrorView = isLocal && !mediaSettings?.isScreenShared;
  useEffect(() => {
    if (isLocal && mediaSettings.isPublished) {
      antmedia.enableAudioLevelForLocalStream((value: number) => {
        enableAudioLevelLocalStream(
          value,
          isTalking,
          setIsTalking,
          timeoutRef,
          antmedia,
          mediaSettings
        );
      }, 800);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mediaSettings.isPublished]);

  return isLocal || props.track?.kind === "audio" ? (
    <>
      <div role={"button"}
        tabIndex={0}
        className="w-[100%] h-[100%] relative"
      >
        <div className={`single-video-card h-[100%]`}>
          <div
            className={clsx("h-[100%] bg-gray-200 rounded-lg", { "hidden": isOff })}
          >
            <DummyCard name={name ?? ""} />
          </div>

          <div
            className={clsx("h-[100%] bg-transparent", { "mirror": mirrorView })}
          >
            <audio
              className={clsx("draggable w-[100%] h-[100%] center object-cover"
                , { "object-contain": mediaSettings?.screenSharedVideoId === props?.id }
                , { "rounded-lg": !pinned })}
              {...props}
              ref={refVideo}
              playsInline
            >
              <track src="captions_en.vtt" kind="captions" srcLang="en" label="english_captions"></track>
            </audio>
          </div>
          <div
            className={clsx("flex flex-row")}>
            {audioView(mic, props, srcobj)}

          </div>

        </div>
      </div>
    </>
  ) : (
    <>
      <audio
        className="hidden"
        {...props}
        ref={refVideo}
        playsInline
      >
        <track src="captions_en.vtt" kind="captions" srcLang="en" label="english_captions"></track>
      </audio>
    </>
  );
});
AudioCard.displayName = 'Audio Card';
export default AudioCard;
